import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { EntityState } from '@api/models/enums/EntityState';
import { SafetyEquipmentDto } from '@api/models/invitation/SafetyEquipmentDto';
import { safetyEquipmentService } from '@api/services/services';

export interface SafetyEquipmentListFilter extends ListFilter {
  state?: EntityState;
}

export type SafetyEquipmentListState = ListType<SafetyEquipmentDto, SafetyEquipmentListFilter>;

const initialState: SafetyEquipmentListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'name',
    sortDesc: false,
  },
};

export const safetyEquipmentListSlice = listSlice({
  name: 'safetyEquipmentList',
  initialState,
});

export const selectSafetyEquipmentList = (state: RootState) => state.safetyEquipmentList;
export const safetyEquipmentListActions = safetyEquipmentListSlice.actions;

export const getSafetyEquipmentList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectSafetyEquipmentList(storeState);

  const handleGetData = (size: number) => {
    return safetyEquipmentService.query(
      {
        q: data.query.q,
        state: data.query.state,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: safetyEquipmentListActions,
    getData: handleGetData,
  });
};
